import(/* webpackMode: "eager" */ "/vercel/path0/app/login/page.jsx");
